
<template>
  <v-container>
    <v-row>
      <v-col
        cols=6
        md=2
      >
        <v-menu
          ref="dateMenu"
          :close-on-content-click="false"
          v-model="dateMenu"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          >

          <template v-slot:activator="{ on }">
            <v-text-field
              autocomplete="off"
              v-model="dateFormatted"
              :label="$t('application_date')"
              hint="DD/MM/YYYY format"
              @blur="date = parseDate(dateFormatted)"
              :rules="[v => !!v || $t('request_date_required')]"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            no-title
            @input="dateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols=6 md=2>
        <v-menu
            ref="timeMenu"
            v-model="timeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="time"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                slot="activator"
                v-model="time"
                :label="$t('time')"
                hint="HH:MM format"
                v-bind="attrs"
                v-on="on"
                :rules="[v => !!v || $t('request_time_required')]"
                autocomplete="off"
              ></v-text-field>
            </template>
            <v-time-picker
              format="24hr"
              v-if="timeMenu"
              v-model="time"
              full-width
              @click:minute="$refs.timeMenu.save(time)"
            ></v-time-picker>
          </v-menu>
      </v-col>
      <v-col md=1>
        <v-btn
          block
          :x-large="$vuetify.breakpoint.mdAndUp"
          :small="$vuetify.breakpoint.smAndDown"
          elevation="1"
          plain
          @click="updateTime"
        >{{ $t('now')}}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'RequestTime',
  data: vm => ({
    dateFormatted: '',
    dateMenu: false,
    timeMenu: false,
    time: '',
    date: vm.parseDate(vm.dateString())
  }),
  watch: {
    date (_) {
      this.dateFormatted = this.formatDate(this.date)
    }
  },
  methods: {
    updateTime: function () {
      var now = new Date()
      this.date = this.parseDate(this.dateString(now))
      this.dateFormatted = this.formatDate(this.date)
      this.time =
        now.getHours().toString().padStart(2, '0') +
        ':' +
        now.getMinutes().toString().padStart(2, '0')
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getData: function () {
      return {
        date: this.dateFormatted,
        time: this.time
      }
    },
    setData: function (data) {
      this.dateFormatted = data.date
      this.time = data.time
    },
    dateString: function (date = new Date()) {
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      return `${day}/${month}/${year}`
    }
  }
}
</script>
